import { render, staticRenderFns } from "./classmanage.vue?vue&type=template&id=a7d74b98&scoped=true"
import script from "./classmanage.vue?vue&type=script&lang=js"
export * from "./classmanage.vue?vue&type=script&lang=js"
import style0 from "./classmanage.vue?vue&type=style&index=0&id=a7d74b98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d74b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d74b98')) {
      api.createRecord('a7d74b98', component.options)
    } else {
      api.reload('a7d74b98', component.options)
    }
    module.hot.accept("./classmanage.vue?vue&type=template&id=a7d74b98&scoped=true", function () {
      api.rerender('a7d74b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantClass/classmanage.vue"
export default component.exports